import type {
  GetAutocourseListServiceConfig,
  GetAutocourseSingleByIdServiceConfig,
} from '@/services/httpServices/AutocourseServices/types';

import { createQueryKey } from './queryKeyUtils';

export function autocourseListKeys(config?: GetAutocourseListServiceConfig) {
  return createQueryKey(['autocourseQueryList'], config);
}

export function autocourseByIdKeys(config?: GetAutocourseSingleByIdServiceConfig) {
  return createQueryKey(['autocourseById'], config);
}
